import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { formconfig } from './formconfig';
import { environment } from '../../../environments/environment';
import { FormTemplate } from '../../Template/formtemplate/formtemplate';
import { Database } from '../../Master/database/database';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');

@Injectable({
  providedIn: 'root'
})
export class FormconfigService {

  constructor(private httpClient: HttpClient) { }
  baseUrl: string = environment.serviceUrl;


  getDatabase(): Observable<Database[]> {
    return this.httpClient.get<Database[]>(this.baseUrl + 'api/DatabaseApi')
  }

  getFormConfig(): Observable<formconfig[]> {
    return this.httpClient.get<formconfig[]>(this.baseUrl + 'api/FormConfigApi/');
  };

  getFormTemplates(): Observable<FormTemplate[]> {
    return this.httpClient.get<FormTemplate[]>(this.baseUrl + 'api/FormTemplateApi');
  }


  Post(frmConfig: formconfig): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormConfigApi/add', frmConfig, { headers: header, observe: 'response' })
  }

  Put(frmConfig: formconfig): Observable<any> {
    return this.httpClient.put<any>(this.baseUrl + 'api/FormConfigApi/Update', frmConfig, { headers: header, observe: 'response' })
  }
  Delete(frmConfig: formconfig) {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormConfigApi/activeordeactive', frmConfig, { headers: header, observe: 'response' })
  }

  getFieldAlias(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormTemplateApi/GetActiveFieldAlias');
  }
  getFederalDatabaseId(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/CommonFunctionApi/GetFederalDatabaseId');
  }
  getFormConfigDisplayField(id: number): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormConfigApi/GetFormConfigDashboardField/' + id);
  }
}
